<template>
  <iframe
    v-if="canOpen === 'can_open'"
    width="100%"
    style="height: calc(100vh - 7px);"
    :src="'/pdfjs/web/viewerWithDownloadAndPrint.html?file=' + srcUrl"
    id="viewer"
  />
  <iframe
    v-else
    width="100%"
    style="height: calc(100vh - 7px);"
    :src="'/pdfjs/web/viewer.html?file=' + srcUrl"
  />
</template>

<script>
import axios from "axios";

import { mapActions, mapState } from "vuex";
import * as helper from "@/utils/helper-methods";

export default {
  name: "RegPDFJSViewer",
  props: [],
  data() {
    return {
      baseREGApiUrl: window.env.VUE_APP_API_REG_DEV,
      baseSLGLApiUrl: window.env.VUE_APP_API_SLGL_DEV,
      srcUrl: "",
      linkForDownload: "",
    };
  },
  computed: {
    ...mapState(["userInfoState"]),
    canOpen() {
      if (this.userInfoState) {
        return "can_open";
      } else {
        return "not_logged_in";
      }
    },
  },
  mounted() {
    this.setShowLayout(false);
    var self = this;
    axios
      .get(this.baseREGApiUrl + "viewPdf?actId=" + this.$route.params.actId, {
        responseType: "blob",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        this.linkForDownload = document.createElement("a");

        const fileurl = URL.createObjectURL(blob);
        this.linkForDownload.href = fileurl;
        this.srcUrl = fileurl;
        this.hideChat();
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = "/";
        }
      });
    helper.EventListenerForDownloadAndPrintDoc(self);
  },
  methods: {
    ...mapActions(["setShowLayout"]),
    hideChat() {
      var chatElement = document.getElementById("lz_overlay_chat");
      if (chatElement) chatElement.style.display = "none";
    },
  },
};
</script>
